import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { MAIN_SECTIONS, ROUTING, TAG_MEMORY, PATH } from '../../../constants';
import './SideMenu.css';
import { menuSwitch } from '../../../redux/actions';

const SideMenu = ({ menuVisible, menuOverlay, switchMenu }) => {
  const menuItems = MAIN_SECTIONS.map((item, index) => (
    <NavLink
      key={item.range}
      className="btn-category"
      activeClassName="selected"
      to={`${ROUTING.CATEGORY}/${index}`}
    >
      <img
        className="ico"
        src={`${PATH.IMG}ico/link/ico-link-${index}.png`}
        alt={item.title}
      />
      <div className="range">{item.range}</div>
      <div className="title">{item.title.toUpperCase()}</div>
    </NavLink>
  ));

  // base styles
  const imgLinkStyle = {
    backgroundImage: `url(${PATH.IMG}menu/menu-sheet.png)`,
  };

  // menu style
  const menuStyle = {
    width: menuVisible ? 220 : 0,
  };

  return (
    <div
      id="side-menu"
      style={menuStyle}
    >
      <div
        id="side-menu-wrap"
        onClick={() => {
          if (menuOverlay) {
            switchMenu();
          }
        }}
      >

        <Link to={ROUTING.HOME}>
          <img
            className="logo"
            src={`${PATH.IMG}menu/menu-logo.png`}
            alt="Logo Toto100letí"
          />
        </Link>
        <div className="btn-category-wrap">
          {menuItems}
        </div>
        <a
          className="img-link tv"
          href="//www.ceskatelevize.cz/specialy/totostoleti/program-68"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            className="link-in"
            style={imgLinkStyle}
          />
        </a>
        <Link
          className="img-link vysilani"
          to={ROUTING.VYSILANI}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <a
          className="img-link anniversary"
          href="//www.ceskatelevize.cz/porady/vyroci/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            className="link-in"
            style={imgLinkStyle}
          />
        </a>
        <Link
          className="img-link memory"
          to={`${ROUTING.TAG}/${TAG_MEMORY}`}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <Link
          className="img-link school"
          to={ROUTING.SCHOOL}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <Link
          className="img-link map"
          to={ROUTING.MAP}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
        <Link
          className="img-link about"
          to={ROUTING.ABOUT}
        >
          <div
            style={imgLinkStyle}
            className="link-in"
          />
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  menuVisible: state.resize.menuVisible,
  menuOverlay: state.resize.menuOverlay,
});

const mapDispatchToProps = dispatch => ({
  switchMenu: () => dispatch(menuSwitch()),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideMenu));



// WEBPACK FOOTER //
// ./src/components/App/SideMenu/SideMenu.js